import InquiryApi from '@apis/inquiry/InquiryApi';
import queries from '@apis/queries';
import { GetInquiriesParams } from '@models/inquiry';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getNextPageParam } from '@utils/slice';

function useInquiries() {
    const params: Omit<GetInquiriesParams, 'page'> = {
        size: 10,
    };
    const queryInfo = useInfiniteQuery({
        queryKey: queries.inquiry.list(params).queryKey,
        queryFn: ({ pageParam }) => InquiryApi.getInquiries({
            ...params, page: pageParam,
        }),
        initialPageParam: 0,
        getNextPageParam,
    });
    const inquiries = getFlattenPageResponse(queryInfo);
    return {
        ...queryInfo,
        inquiries,
    };
}

export default useInquiries;
